/**
 * Copy of shopify/bat-component-water-report-form-ewg.js for reference.
 * Upload to theme Assets as bat-component-water-report-form-ewg.js
 */
(function () {
  function getApiBaseUrl(props) {
    var fromProps = props && props.api_base_url;
    if (fromProps) return String(fromProps).replace(/\/$/, "");

    var cfg =
      window.WATER_REPORT_FORM_CONFIG ||
      window.EWG_REPORT_DISPLAY_CONFIG ||
      window.EWG_WATER_REPORT_CONFIG ||
      {};
    var url = cfg.apiBaseUrl || cfg.API_BASE_URL || "";
    return String(url).replace(/\/$/, "");
  }

  function providerLabel(provider) {
    var parts = [provider.name || "Unknown provider"];
    if (provider.location) parts.push(provider.location);
    if (provider.is_primary) parts.push("Recommended");
    return parts.join(" - ");
  }

  function mapProvider(provider, props) {
    var pwsId = (provider.pws_id || "").trim();
    var retailBase =
      (props && props.retail_page_base_url) ||
      "https://www.tyentusa.com/pages/free-drinking-water-report";
    var reportBase =
      (props && props.report_page_base_url) ||
      "https://www.tyentusa.com/pages/water-wizard";

    return {
      value: pwsId,
      text: providerLabel(provider),
      reportUrl: reportBase + "?r=" + encodeURIComponent(pwsId),
      retailUrl: retailBase + "?r=" + encodeURIComponent(pwsId),
      pwsId: pwsId,
    };
  }

  const waterReportForm = (props) => ({
    zipCode: "",
    waterProviders: [],
    selectedProvider: "",
    selectedProviderRetailUrl: "",
    isLoading: false,
    showProviderSelect: false,
    typingTimer: null,
    doneTypingInterval: 1000,
    firstName: "",
    phoneNumber: "",
    email: "",
    klaviyoListId: props.klaviyo_list_id,
    klaviyoFormSubmissionEventName: props.klaviyo_form_submission_event_name,
    thankYouPageUrl: props.thank_you_page_url,
    formType: props.form_type,
    klaviyo_water_report_bucket_name: props.klaviyo_water_report_bucket_name,
    apiBaseUrl: getApiBaseUrl(props),

    init() {
      this.$watch("showPersonDetails", (newValue, oldValue) => {
        if (newValue !== oldValue) {
          this.firstName = this.$refs.firstName.value;
          this.phoneNumber = this.$refs.phoneNumber.value;
          this.email = this.$refs.email.value;
        }
      });
    },

    get showPersonDetails() {
      return !!this.selectedProvider;
    },

    async getAreas() {
      var zip = String(this.zipCode || "")
        .replace(/\D/g, "")
        .slice(0, 5);

      if (!zip) {
        this.showProviderSelect = false;
        this.waterProviders = [];
        this.selectedProvider = "";
        this.selectedProviderRetailUrl = "";
        return;
      }

      if (zip.length !== 5) {
        this.showProviderSelect = false;
        this.waterProviders = [];
        return;
      }

      if (!this.apiBaseUrl) {
        console.error(
          "Water report form: set apiBaseUrl via EWG_REPORT_DISPLAY_CONFIG or WATER_REPORT_FORM_CONFIG"
        );
        this.waterProviders = [];
        this.showProviderSelect = false;
        return;
      }

      this.isLoading = true;
      this.selectedProvider = "";
      this.selectedProviderRetailUrl = "";

      try {
        var response = await fetch(
          this.apiBaseUrl + "/api/providers?zip=" + encodeURIComponent(zip)
        );
        if (!response.ok) {
          throw new Error(response.statusText || "Could not load providers");
        }

        var data = await response.json();
        var providers = data.providers || [];
        var seen = new Set();
        var uniqueProviders = [];

        for (var i = 0; i < providers.length; i++) {
          var mapped = mapProvider(providers[i], props);
          if (!mapped.value || seen.has(mapped.value)) continue;
          seen.add(mapped.value);
          uniqueProviders.push(mapped);
        }

        this.waterProviders = uniqueProviders;
        this.showProviderSelect = this.waterProviders.length > 0;

        var primary = uniqueProviders.find(function (p) {
          return providers.some(function (raw) {
            return raw.pws_id === p.pwsId && raw.is_primary;
          });
        });
        if (primary) {
          this.selectedProvider = primary.value;
          this.selectedProviderRetailUrl = primary.retailUrl;
        }
      } catch (error) {
        console.error("Error fetching water providers:", error);
        this.waterProviders = [];
        this.showProviderSelect = false;
      } finally {
        this.isLoading = false;
      }
    },

    onZipInput() {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(() => {
        this.getAreas();
      }, this.doneTypingInterval);
    },

    onProviderChange() {
      if (this.selectedProvider) {
        var provider = this.waterProviders.find(
          (p) => p.value === this.selectedProvider
        );
        if (provider) {
          this.selectedProviderRetailUrl = provider.retailUrl;
        }
      } else {
        this.selectedProviderRetailUrl = "";
      }
    },

    async handleZipForm() {
      if (this.zipCode.trim()) {
        if (this.waterProviders.length > 0 && !this.selectedProvider) {
          console.log("Please select a water provider");
          return;
        }

        console.log("Submitting water report for ZIP:", this.zipCode);

        if (this.selectedProvider) {
          var provider = this.waterProviders.find(
            (p) => p.value === this.selectedProvider
          );
          await this.track();
          if (provider) {
            window.location.href = this.thankYouPageUrl;
          }
        } else {
          console.log("No water providers found for this ZIP code");
        }
      } else {
        console.log("Please enter a ZIP code");
      }
    },

    async handleEmailForm() {
      await this.track();
      window.location.href = this.thankYouPageUrl;
    },

    async submitForm() {
      if (this.formType === "zip") {
        await this.handleZipForm();
      } else {
        await this.handleEmailForm();
      }
    },

    async track() {
      await this.klaviyoTrack();

      var settings = {
        async: true,
        crossDomain: true,
        url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
        method: "POST",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          "cache-control": "no-cache",
        },
        data: {
          g: this.klaviyoListId,
          email: this.email,
          $fields:
            "$source, $first_name, $phone, $zip, address_home_zip, water_report_retail_url, water_report_bucket_name",
          $source: "Water Report Form",
          ...(this.formType === "zip"
            ? {
                $first_name: this.firstName,
                $phone: this.phoneNumber,
                $zip: this.zipCode,
                address_home_zip: this.zipCode,
                water_report_retail_url: this.selectedProviderRetailUrl,
                water_report_bucket_name: this.klaviyo_water_report_bucket_name,
              }
            : {}),
        },
      };

      await fetch(settings.url, {
        method: settings.method,
        headers: settings.headers,
        body: new URLSearchParams(settings.data),
      });
    },

    async klaviyoTrack() {
      const KLAVIYO_PUBLIC_API_KEY = "XLkecu";

      try {
        const properties = {
          $email: this.email,
          ...(this.formType === "zip" && {
            $first_name: this.firstName,
            first_name: this.firstName,
            $phone_number: this.phoneNumber,
            phone: this.phoneNumber,
            $zip: this.zipCode,
            address_home_zip: this.zipCode,
            water_report_retail_url: this.selectedProviderRetailUrl,
            water_report_bucket_name: this.klaviyo_water_report_bucket_name,
          }),
        };

        const identifyOptions = {
          method: "POST",
          headers: {
            accept: "text/html",
            "content-type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({
            data: JSON.stringify({
              token: KLAVIYO_PUBLIC_API_KEY,
              properties: properties,
            }),
          }),
        };

        await fetch("https://a.klaviyo.com/api/identify", identifyOptions)
          .then((res) => res.json())
          .then((res) => console.log(res))
          .catch((err) => console.error(err));

        const trackOptions = {
          method: "POST",
          headers: {
            accept: "text/html",
            "content-type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({
            data: JSON.stringify({
              token: KLAVIYO_PUBLIC_API_KEY,
              event: this.klaviyoFormSubmissionEventName,
              customer_properties: {
                $email: this.email,
              },
              properties: {
                url: window.location.href,
                water_report_bucket_name: this.klaviyo_water_report_bucket_name,
              },
            }),
          }),
        };

        await fetch("https://a.klaviyo.com/api/track", trackOptions)
          .then((res) => res.json())
          .then((res) => console.log(res))
          .catch((err) => console.error(err));

        console.log("Klaviyo identify + track completed successfully");
      } catch (err) {
        console.error("Error sending Klaviyo events:", err);
      }
    },
  });

  document.addEventListener("alpine:init", () => {
    Alpine.data("waterReportForm", waterReportForm);
  });

  if (window.Alpine) {
    Alpine.data("waterReportForm", waterReportForm);
  }
})();